// Pop-up variant pickers opened from the comparison table (sections/agecode-compare.liquid)
if (!window.agecodeModalsReady) {
  window.agecodeModalsReady = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-agecode-modal-open]');
    if (opener) {
      document.getElementById(opener.dataset.agecodeModalOpen)?.showModal();
      return;
    }

    if (event.target.closest('[data-agecode-modal-close]')) {
      event.target.closest('dialog').close();
      return;
    }

    // Click on the backdrop (outside the dialog box) closes it
    const dialog = event.target;
    if (dialog.matches && dialog.matches('dialog.agecode-modal')) {
      const rect = dialog.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    }
  });

  // Close the pop-up once the item is in the cart so a cart drawer/notification isn't hidden behind it
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      document.querySelectorAll('dialog.agecode-modal[open]').forEach((dialog) => dialog.close());
    });
  }
}

if (!customElements.get('agecode-variant-picker')) {
  customElements.define(
    'agecode-variant-picker',
    class AgecodeVariantPicker extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('script[type="application/json"]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.productForm = this.closest('product-form');
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        const selected = Array.from(this.querySelectorAll('fieldset')).map(
          (fieldset) => fieldset.querySelector('input:checked')?.value
        );
        const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
        const idInput = this.productForm.querySelector('.product-variant-id');
        const submit = this.productForm.querySelector('[type="submit"]');
        const label = submit.querySelector('span');
        const price = this.productForm.querySelector('[data-agecode-price]');

        if (!variant) {
          idInput.disabled = true;
          submit.setAttribute('disabled', 'disabled');
          label.textContent = window.variantStrings.unavailable;
          return;
        }

        idInput.value = variant.id;
        idInput.disabled = false;
        if (price) price.innerHTML = variant.price_html;

        if (variant.available) {
          submit.removeAttribute('disabled');
          label.textContent = window.variantStrings.addToCart;
        } else {
          submit.setAttribute('disabled', 'disabled');
          label.textContent = window.variantStrings.soldOut;
        }
      }
    }
  );
}
